/**
 * How to get the words out of a PDF, in the three ways the Worker can do it.
 *
 * All three run in the Worker, in JavaScript — there is no Python here, and the
 * equivalents for anyone who knows the usual tools are:
 *
 *   pdftotext / pdfplumber / PyMuPDF  ->  'layer', pdf.js via unpdf
 *   pdfimages                         ->  the picture scanner, which runs on every
 *                                         import regardless of the mode below
 *   OCRmyPDF / Tesseract              ->  'vision', a vision model reading the pages
 *
 * Only the first is exact and free; the other two exist for a scan, which is a
 * picture of a page with no text in it to read.
 */
export const PDF_MODES = [
  {
    value: 'layer',
    label: 'Text layer only',
    short: 'Reads the PDF’s own text. No model, no AI credits, exact characters.',
    note: 'Reads the PDF’s own text layer with pdf.js — the pdftotext/PyMuPDF equivalent. No model, no AI credits, exact characters. Comes back empty for a scan.',
  },
  {
    value: 'auto',
    label: 'Text layer, then AI',
    short: 'Text layer first; falls back to document conversion, then to a vision model.',
    note: 'Tries the text layer first, and only if it comes back empty falls back to Cloudflare’s document conversion and then to a vision model reading the pages.',
  },
  {
    value: 'vision',
    label: 'Vision OCR',
    short: 'A vision model reads the pages as pictures. For scans. Up to four pages.',
    note: 'Skips the text layer and has a vision model read the pictures the pages are made of — the OCRmyPDF/Tesseract equivalent, done by a model. For scans. Up to four pages.',
  },
]

export const pdfMode = (value) => PDF_MODES.find((m) => m.value === value)
